import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { BarChart, Bar, PieChart, Pie, Cell, ResponsiveContainer, XAxis, YAxis, Tooltip, Legend } from "recharts";

const ChartBox = ({ children }) => (
  <div style={{ width: "100%", height: 280, minHeight: 280 }}>{children}</div>
);

const COLORS = ["#1A3A5C", "#2E75B6", "#5882AE", "#F59E0B", "#10B981", "#EF4444", "#8B5CF6"];

export default function Report() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/reports/stats").then(r => setStats(r.data)).catch(()=>setStats({ by_type: [], by_status: [], workload: [] })); }, []);

  if (!stats) return <div className="text-sm text-slate-500">Caricamento...</div>;

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-heading font-bold text-navy-900">Report</h1>
        <p className="text-sm text-slate-500 mt-1">Analisi e statistiche dello studio</p>
      </div>

      <div className="grid lg:grid-cols-2 gap-5">
        <Card className="p-5">
          <div className="font-heading font-semibold text-navy-900 mb-4">Pratiche per tipo</div>
          <ChartBox>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={stats.by_type} dataKey="count" nameKey="_id" cx="50%" cy="50%" outerRadius={90} label>
                  {stats.by_type.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip /><Legend />
              </PieChart>
            </ResponsiveContainer>
          </ChartBox>
        </Card>

        <Card className="p-5">
          <div className="font-heading font-semibold text-navy-900 mb-4">Pratiche per stato</div>
          <ChartBox>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={stats.by_status}>
                <XAxis dataKey="_id" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} />
                <Tooltip />
                <Bar dataKey="count" fill="#2E75B6" />
              </BarChart>
            </ResponsiveContainer>
          </ChartBox>
        </Card>

        <Card className="p-5 lg:col-span-2">
          <div className="font-heading font-semibold text-navy-900 mb-4">Carico di lavoro per collaboratore</div>
          <ChartBox>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={stats.workload} layout="vertical">
                <XAxis type="number" tick={{ fontSize: 11 }} />
                <YAxis dataKey="user" type="category" tick={{ fontSize: 11 }} width={150} />
                <Tooltip />
                <Bar dataKey="count" fill="#1A3A5C" />
              </BarChart>
            </ResponsiveContainer>
          </ChartBox>
        </Card>
      </div>
    </div>
  );
}
